module.exports = __webpack_public_path__ + "static/media/productImg3.f6ed3f92.png";